import CookiesPolicy from "./cookiespolicy.js";

export default CookiesPolicy;
